export default __webpack_public_path__ + "static/media/open.b3336b87.mpeg";